import Styles from './UploadsDrawer.module.scss'
import { maskShapes } from 'components/Design/ElementsTab/components/shapes'
import { MaskShapesGrid } from 'components/Design/ElementsTab/components/MaskShapesGrid'

export const MasksPanel = () => {
  return (
    <div>
      <div className={Styles.sectionContainer}>
        <MaskShapesGrid shapesToDisplay={maskShapes} />
      </div>
    </div>
  )
}
